import { Position } from "@xyflow/react";

export const tabs = [
  {title: 'Predecessors', value: 'predecessors'},
  {title: 'Successors', value: 'successors'}
]

export const nodeDefaults = {
  sourcePosition: Position.Right,
  targetPosition: Position.Left,
};

export const initialNodes = [
  { id: 'n1', position: { x: 0, y: 100 }, data: { label: 'Node 1' }, type: 'custom' },
  { id: 'n2', position: { x: 300, y: 0 }, data: { label: 'Node 2' }, type: 'custom' },
  { id: 'n3', position: { x: 300, y: 50 }, data: { label: 'Node 3' }, type: 'custom' },
  { id: 'n4', position: { x: 300, y: 100 }, data: { label: 'Node 4' }, type: 'custom' },
  { id: 'n5', position: { x: 300, y: 150 }, data: { label: 'Node 5' }, type: 'custom' },
  { id: 'n6', position: { x: 300, y: 200 }, data: { label: 'Node 6' }, type: 'custom' },
  { id: 'n7', position: { x: 600, y: 0 }, data: { label: 'Node 7' }, type: 'custom' },
  { id: 'n8', position: { x: 600, y: 200 }, data: { label: 'Node 8' }, type: 'custom' },
];

export const initialEdges = [
  { id: 'n1-n2', source: 'n1', target: 'n2' },
  { id: 'n1-n3', source: 'n1', target: 'n3' },
  { id: 'n1-n4', source: 'n1', target: 'n4' },
  { id: 'n1-n5', source: 'n1', target: 'n5' },
  { id: 'n1-n6', source: 'n1', target: 'n6' },
  { id: 'n2-n7', source: 'n2', target: 'n7' },
  { id: 'n2-n8', source: 'n2', target: 'n8' }
];